import React, { useCallback } from 'react';
import { Dropdown, IconButton, SelectList } from '@x5-react-uikit/core';
import { sizeTokenValues } from '@x5-react-uikit/tokens';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { StoreState } from 'store';

const Profile = () => {
  const history = useHistory();
  const user = useSelector((state: StoreState) => state.me.user)!;

  const handleDropdownClick = useCallback(
    (event, value) => {
      if (value === 'profile') {
        return history.push('/profile'); // TODO: route constants
      }
      if (value === 'logout') {
        return window.location.replace('/api/logout');
      }
    },
    [history]
  );

  return (
    <Dropdown
      action={
        <IconButton
          size={sizeTokenValues.small}
          variant="text"
          icon="AccountCircle"
        />
      }
      placement="bottom-start"
    >
      <SelectList
        items={[
          user?.login && {
            disabled: true,
            name: user.login,
            value: 'email',
          },
          {
            name: 'Выход',
            value: 'logout',
          },
        ].filter(Boolean)}
        onChange={handleDropdownClick}
        selected={[]}
      />
    </Dropdown>
  );
};

export default Profile;
